import { DatePicker, RangePickerProps } from 'components/DatePicker';
import { memo, useCallback, useEffect, useState } from 'react';
import { demoDataDateRange, isDemoChannel } from 'services/channels/demo';

/**
 * 演示用渠道包大部分接口需要限制在特殊日期内才能获取有效数据，
 * 因此使用HOC进行一层特殊封装，尽量不暴露在上层调用。
 * @思睿 @haofeng.zhao @褚善博
 * @param props
 * @returns
 */
const RangePickerForDemo = (props: RangePickerProps) => {
  const { onChange } = props;
  useEffect(() => {
    const [startMoment] = demoDataDateRange;
    if (onChange) {
      const start = startMoment.clone();
      const end = startMoment.clone().add(7, 'd');
      onChange([start, end], ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DatePicker.RangePicker
      {...props}
      disabledDate={useCallback((target) => {
        const [startMoment, endMoment] = demoDataDateRange;
        const startTs = startMoment.valueOf();
        const endTs = endMoment.valueOf();
        const targetTs = target?.valueOf?.();
        const inRange = targetTs >= startTs && targetTs <= endTs;
        return !inRange;
      }, [])}
    />
  );
};

const RangePickerCompat = isDemoChannel ? memo(RangePickerForDemo) : DatePicker.RangePicker;

/**
 * https://leyan.yuque.com/ued_yeah/pwvc4q/21832494?artboard_type=artboard&view=&from=
 */
export default memo((props: RangePickerProps) => {
  const { value, onOpenChange, ...otherProps } = props;

  const [dates, setDates] = useState<RangePickerProps['value']>(null);

  return (
    <RangePickerCompat
      value={dates || value}
      onOpenChange={useCallback(
        (open) => {
          if (open) {
            setDates([null, null]);
          } else {
            setDates(null);
          }

          if (onOpenChange) {
            onOpenChange(open);
          }
        },
        [onOpenChange],
      )}
      {...otherProps}
    />
  );
});
